import { cn } from "@/lib/utils";

function Bar({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded bg-muted", className)} />;
}

export function UnpaidSkeleton() {
  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block">
        <div className="overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm">
          <div className="bg-muted/40 px-4 py-3">
            <div className="flex gap-10">
              {Array.from({ length: 6 }).map((_, i) => (
                <Bar key={i} className="h-3 w-14" />
              ))}
            </div>
          </div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "flex items-center gap-6 px-4 py-3",
                i !== 5 && "border-b border-border/40",
              )}
            >
              <Bar className="size-[18px] rounded-[5px]" />
              <div className="space-y-1">
                <Bar className="h-3.5 w-16" />
                <Bar className="h-2.5 w-10 bg-muted/50" />
              </div>
              <div className="flex flex-1 items-center gap-2.5">
                <div className="size-7 animate-pulse rounded-full bg-muted" />
                <div className="space-y-1">
                  <Bar className="h-3.5 w-24" />
                  <Bar className="h-2.5 w-32 bg-muted/50" />
                </div>
              </div>
              <div className="flex flex-1 items-center gap-2.5">
                <div className="size-7 animate-pulse rounded-full bg-muted" />
                <Bar className="h-3.5 w-28" />
              </div>
              <div className="space-y-1 text-right">
                <Bar className="ml-auto h-3.5 w-16" />
                <Bar className="ml-auto h-2.5 w-24 bg-muted/50" />
              </div>
              <Bar className="h-3.5 w-14" />
              <Bar className="h-7 w-20 rounded-full bg-muted/50" />
            </div>
          ))}
        </div>
      </div>
      {/* Mobile/Tablet */}
      <div className="grid gap-3 sm:grid-cols-2 lg:hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm"
          >
            <div className="flex items-start justify-between">
              <Bar className="h-3.5 w-32" />
              <Bar className="size-5 rounded-[5px]" />
            </div>
            <div className="mt-3 space-y-2">
              <div className="flex items-center gap-2">
                <div className="size-6 animate-pulse rounded-full bg-muted" />
                <Bar className="h-3.5 w-24" />
              </div>
              <div className="flex items-center gap-2">
                <div className="size-6 animate-pulse rounded-full bg-muted" />
                <Bar className="h-3.5 w-28" />
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between border-t border-border/40 pt-3">
              <Bar className="h-3.5 w-20" />
              <Bar className="h-7 w-14 rounded-md bg-muted/50" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export function HistorySkeleton() {
  return (
    <>
      <div className="hidden lg:block">
        <div className="overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm">
          <div className="bg-muted/40 px-3 py-2.5">
            <div className="flex gap-10">
              {Array.from({ length: 7 }).map((_, i) => (
                <Bar key={i} className="h-3 w-12" />
              ))}
            </div>
          </div>
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "flex items-center gap-8 px-3 py-3",
                i !== 4 && "border-b border-border/40",
              )}
            >
              <Bar className="size-3.5 bg-muted/50" />
              <Bar className="h-3.5 w-16" />
              <div className="flex items-center gap-2">
                <div className="size-6 animate-pulse rounded-full bg-muted" />
                <Bar className="h-3.5 w-28" />
              </div>
              <Bar className="ml-auto h-3.5 w-16" />
              <Bar className="h-3.5 w-8 bg-muted/50" />
              <Bar className="h-3.5 w-20 bg-muted/50" />
              <Bar className="h-3.5 w-24 bg-muted/50" />
            </div>
          ))}
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm"
          >
            <div className="flex items-center justify-between">
              <div className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <div className="size-6 animate-pulse rounded-full bg-muted" />
                  <Bar className="h-3.5 w-28" />
                </div>
                <Bar className="h-3 w-32 bg-muted/50" />
              </div>
              <Bar className="h-4 w-16" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
